<template>
  <el-dialog
    class="radish-dia"
    :title="'批量' + type + '职能模块'"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>
      <el-select v-model="val" size="mini" multiple filterable>
        <el-option v-for="(op, k) in options" :key="k" :label="op" :value="op"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      type: '',
      ids: [],
      val: [],
      options: [],
    }
  },
  methods: {
    show: function(type, cats, ids) {
      this.type = type
      this.val = []
      const role = app.user['角色']
      if (type == '添加' || (role && role.includes('管理员'))) {
        this.options = cats.map(item => item['名称'])
      } else {
        const prem = app.user['SL权限']
        const catArr = prem.split(';')
        this.options = catArr
      }
      this.ids = ids
      this.dialogVisible = true
    },
    handleConfirm: function() {
      const val = this.val
      this.$confirm(`确定批量${this.type}职能模块${val}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let result
          if (this.type == '添加') {
            result = await app.service('radish').modifyByIds({
              ids: this.ids,
              $addToSet: { 职能模块: { $each: val } },
            })
          } else if (this.type == '删除') {
            result = await app.service('radish').modifyByIds({
              ids: this.ids,
              $pull: { 职能模块: { $in: val } },
            })
          }
          if (result.status == 'success') {
            await this.onConfirm()
            this.dialogVisible = false
          } else {
            this.$message.error(result.msg)
          }
        })
        .catch(() => {})
    },
  },
}
</script>
